
export * from './tips.module';
export * from './components/tip-page/tip-page';
export * from './services/tip.service';
export * from './model/model';
